import request from '@/utils/request';

let login=()=>request.get('/api/user/login?userName=raunicorn')
let logout=()=>request.get('/api/user/logout')

export default {
  login,
  logout
}